import lightThemeColors from './colors/lightThemeColors.mjs';
import theme from './theme.mjs';

var lightTheme = Object.assign(Object.assign({}, theme), { name: 'light', colors: lightThemeColors, gradients: {
        imageOverlay: `linear-gradient(180deg, transparent 29.66%, ${lightThemeColors.white} 89.13%)`,
        heroImageOverlay: `linear-gradient(180deg, transparent 27.3%, ${lightThemeColors.slate} 82.04%)`,
        heroImageUnderlay: `linear-gradient(180deg, ${lightThemeColors.slate}66 0%, ${lightThemeColors.slate} 82.1%)`,
        platformsOverlay: `linear-gradient(180deg, transparent 25.38%, ${lightThemeColors.white}E8 71.45%, ${lightThemeColors.white} 100%)`,
        videoOverlay: `linear-gradient(180deg, ${lightThemeColors.white} 0%, ${lightThemeColors.white} 105.89%)`,
        videoControlBarOverlay: `linear-gradient(180deg, ${lightThemeColors.slate}00 0%, ${lightThemeColors.slate}80 100%)`,
        horizontalCarousel: {
            prevButton: `linear-gradient(270deg, ${lightThemeColors.white}00 0%, ${lightThemeColors.white} 100%)`,
            nextButton: `linear-gradient(270deg, ${lightThemeColors.white} 0%, ${lightThemeColors.white}00 100%);`
        },
        horizontalList: {
            nextOverlay: `linear-gradient(270deg, ${lightThemeColors.white} 0%, ${lightThemeColors.white}00 100%)`,
            prevOverlay: `linear-gradient(90deg, ${lightThemeColors.white} 0%, ${lightThemeColors.white}00 100%)`
        },
        mediaCardSkeletonLoading: `linear-gradient(90deg, transparent 0%, ${lightThemeColors.white}B3 39.5%, ${lightThemeColors.white}B3 59.5%, transparent 100%)`
    }, shadows: {
        topNavigationTooltip: `0 0 10px 0 ${lightThemeColors.midnightBlue}33`
    } });

export { lightTheme as default };
//# sourceMappingURL=lightTheme.mjs.map
